<script>
import TempalteSelector from './TempalteSelector.vue'
import nodeID from '@/mixins/nodeID'
import { getMetadataYamlByCategory } from '@/api/metadata'
import { DEFAULT_RESOURCE_TYPE } from '@/utils/constants'

export default {
  name: 'ConfKeySelector',

  extends: TempalteSelector,

  props: {
    category: { type: String, default: DEFAULT_RESOURCE_TYPE }, // sources | sinks | functions | ops | connections
    type: { type: String, default: '' }, //  edgex| mqtt。Only `edgex` and `mqtt` support connectionSelector
  },

  mixins: [nodeID],

  watch: {
    type: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.init()
        } else {
          this.myValue = ''
          this.list = []
        }
      },
    },
  },

  created() {},

  methods: {
    async init() {
      this.list = await this.getList()
    },
    getList() {
      return new Promise((resolve, reject) => {
        if (this.type) {
          const data = {
            nodeID: this.nodeID,
            name: this.type,
          }
          getMetadataYamlByCategory(this.category, data)
            .then((res) => {
              const { data: allConfKeysData } = res
              const confKeyList = Object.keys(allConfKeysData)
              resolve(confKeyList)
            })
            .catch((error) => {
              reject(error)
            })
        } else {
          resolve([])
        }
      })
    },
  },
}
</script>
